/**
 * Language the medicaprof AI writes its radiology reports in.
 *
 * Set in the viewer's User Preferences and sent as `language` on the Imaging Lab
 * AI requests. The backend allowlists the code again (unknown ones fall back to
 * English), so this list is a UI convenience, not the security boundary.
 */
const STORAGE_KEY = 'medicaprof-ai-report-language';

export const AI_REPORT_LANGUAGES = [
  { value: 'en', label: 'English' },
  { value: 'ar', label: 'العربية' },
  { value: 'fr', label: 'Français' },
];

export const DEFAULT_AI_REPORT_LANGUAGE = 'en';

/** The stored report language, or English when unset/unreadable. */
export function getAiReportLanguage(): string {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored && AI_REPORT_LANGUAGES.some(l => l.value === stored)) {
      return stored;
    }
  } catch (e) {
    /* storage unavailable (private mode) — fall through to the default */
  }
  return DEFAULT_AI_REPORT_LANGUAGE;
}

/** Persist the report language; unknown codes are ignored. */
export function setAiReportLanguage(value: string): void {
  if (!AI_REPORT_LANGUAGES.some(l => l.value === value)) {
    return;
  }
  try {
    window.localStorage.setItem(STORAGE_KEY, value);
  } catch (e) {
    /* storage unavailable — the setting just does not persist */
  }
}

export default {
  AI_REPORT_LANGUAGES,
  DEFAULT_AI_REPORT_LANGUAGE,
  getAiReportLanguage,
  setAiReportLanguage,
};
